import consultations from '@/store/mods/consultations/consultations'
import AvisReponse from '@/components/avis/avis-reponse.vue'
import AvisDossier from '@/components/avis/avis-dossier.vue'

export default {
    name: 'avis-medicaux-recus',
    components: { AvisReponse, AvisDossier },
    data() { return { avis: [], reponses: {}, loading: false, saving: null, error: '', token: '', dossierId: 0, replyError: '', succes: '' } },
    mounted() { this.charger() },
    methods: {
        ouvrirDossier(avis) {
            const editeurs = this.$refs.editeurs || []
            editeurs.forEach(editeur => editeur.arreterDictee())
            this.replyError = ''; this.dossierId = Number(avis.id)
        },
        async charger() {
            if (this.loading) return
            this.loading = true
            this.error = ''
            try {
                const access = await consultations.getTableauMedecinAccess()
                if (!access || access.success !== true || !access.data || !access.data.access_token) throw new Error('Autorisation indisponible.')
                this.token = access.data.access_token
                const result = await consultations.getAvisMedicauxRecus(this.token)
                if (this._isDestroyed) return
                this.avis = Array.isArray(result.data) ? result.data : []
            } catch (error) {
                if (!this._isDestroyed) this.error = error && error.message ? error.message : 'Impossible de charger les avis.'
            } finally {
                if (!this._isDestroyed) this.loading = false
            }
        },
        async repondre(avis) {
            const reponse = (this.reponses[avis.id] || '').trim()
            if (!reponse || reponse.length > 4000 || this.saving || !this.token) return
            this.saving = avis.id
            this.error = ''; this.replyError = ''; this.succes = ''
            try {
                // Les capacités expirent après 120 s : renouveler à l'envoi,
                // même si la lecture du dossier ou la dictée a duré longtemps.
                const access = await consultations.getTableauMedecinAccess()
                if (!access || access.success !== true || !access.data || !access.data.access_token) throw new Error()
                await consultations.repondreAvisMedical(avis.id, { reponse }, access.data.access_token)
                if (!this._isDestroyed) {
                    this.$delete(this.reponses, avis.id)
                    this.dossierId = 0
                    this.succes = 'Votre avis a été enregistré dans le dossier.'
                    await this.charger()
                }
            } catch (error) {
                if (!this._isDestroyed) {
                    this.replyError = error && error.response && error.response.data && error.response.data.message || 'La réponse n’a pas été enregistrée. Votre brouillon est conservé.'
                    this.error = this.replyError
                }
            } finally {
                if (!this._isDestroyed) this.saving = null
            }
        }
    }
}
